import debounce from 'lodash.debounce';

import { trackScreenSearchResultsViewed, trackSearched } from 'events/analytics';
import selfServiceEvents from 'events/selfService';
import trimTrailingCharactersFromString from 'lib/trimTrailingCharactersFromString';

// debounce is stupid and uses setTimeout under the hood
// so we cant use thunk because debounce wont return the function return value
const debouncedSearch = debounce(async (searchTerm, dispatch, getState, { selfServiceGateway }) => {
  if (!searchTerm) {
    return;
  }
  const searchTimestamp = new Date().toISOString();

  dispatch(trackSearched({ searchId: searchTimestamp, searchTerm }));

  const { orgId, orgDomain } = getState().app;
  const { lng } = getState().configuration.config;
  let trimmedSearchTerm = trimTrailingCharactersFromString(searchTerm, ' ');
  trimmedSearchTerm = trimTrailingCharactersFromString(searchTerm, '-');

  const response = await selfServiceGateway.getSearchResults(trimmedSearchTerm, orgId, orgDomain, lng);
  if (response.error) {
    // TODO // noop for now. we should handle this but previously someone was just logging it
    console.log(`${response.error.reason}: ${response.error.err}`); // eslint-disable-line no-console
    return;
  }

  dispatch(
    trackScreenSearchResultsViewed({
      searchId: searchTimestamp,
      searchResults: response.data.map((res, idx) => ({ entityId: res.id, entityType: 'answer', position: idx + 1 })),
      searchTerm,
    })
  );
  dispatch(
    selfServiceEvents.updateSearchResultsSuccess({
      searchTerm,
      results: response.data,
      timestamp: searchTimestamp,
    })
  );
}, 500);

export default function getSearchResults(searchTerm) {
  return async (dispatch, getState, { selfServiceGateway }) => {
    dispatch(selfServiceEvents.updateAnswerSearchTerm(searchTerm));
    debouncedSearch(searchTerm, dispatch, getState, { selfServiceGateway });
  };
}
